import * as React from 'react';
import * as _ from 'lodash';
import {
    Container,
} from './styles';
import Modal from 'components/Modal';

export interface ModalUpsellProps {
    shouldShow: boolean
}

export class ModalUpsell extends React.Component<ModalUpsellProps, {}> {

    constructor(props: ModalUpsellProps) {
        super(props);
    }

    
    render() {
        return (
            <Modal shouldShow={this.props.shouldShow}>
                <Container shouldShow={this.props.shouldShow}>
                {
                    this.props.children
                }
               </Container>
            </Modal>
        );
    }
}